import React from "react";

const Home = () => {
  const categories = [
    { icon: "fa-broom", title: "Home Cleaning", desc: "From dusting to mopping — we make your home shine." },
    { icon: "fa-building", title: "Office Cleaning", desc: "Keep your workspace spotless and professional." },
    { icon: "fa-car", title: "Car Wash", desc: "Premium car detailing and washing at your doorstep." },
    { icon: "fa-soap", title: "Laundry Services", desc: "Quick pickup and delivery laundry for your comfort." },
    { icon: "fa-tree", title: "Garden Care", desc: "Maintain your garden beautifully and effortlessly." },
    { icon: "fa-bug", title: "Pest Control", desc: "Safe and effective pest control solutions." },
  ];

  const testimonials = [
    {
      name: "Rina Das",
      review:
        "I booked a house cleaning and they did an excellent job. On-time, polite staff, and shining results!",
      image: "https://i.pravatar.cc/100?img=1",
    },
    {
      name: "Rahul Verma",
      review:
        "Using Cleanering made my life easier. Booking and service tracking are smooth and transparent.",
      image: "https://i.pravatar.cc/100?img=2",
    },
    {
      name: "Sara Ahmed",
      review:
        "I love how simple it is to find verified cleaners for my office. Highly recommend this service.",
      image: "https://i.pravatar.cc/100?img=3",
    },
  ];

  return (
    <>
      {/* HERO SECTION */}
      <section className="hero">
        <div className="hero-content">
          <h1>
            Welcome to <span>Cleanering</span>
          </h1>
          <p>
            Find trusted cleaning professionals for homes, offices, and more —
            all in one platform.
          </p>
          <a href="/services" className="btn">
            Explore Services
          </a>
        </div>
      </section>

      {/* ABOUT SECTION */}
      <section className="about">
        <div className="about-container">
          <div className="about-text">
            <h2>Why Choose Cleanering?</h2>
            <p>
              Cleanering connects verified service providers with people looking
              for reliable cleaning, maintenance, and household support. Whether
              you are a buyer or a seller, we make managing services easy and
              transparent.
            </p>
            <ul>
              <li><i className="fa-solid fa-check"></i> Verified professionals</li>
              <li><i className="fa-solid fa-check"></i> Easy online booking</li>
              <li><i className="fa-solid fa-check"></i> Affordable pricing</li>
              <li><i className="fa-solid fa-check"></i> 24/7 customer support</li>
            </ul>
          </div>
          <div className="about-image">
            <img
              src="https://images.unsplash.com/photo-1581578017423-1e3e6a8b4b5d?auto=format&fit=crop&w=900&q=80"
              alt="Cleaning team"
            />
          </div>
        </div>
      </section>

      {/* SERVICES PREVIEW */}
      <section className="categories">
        <h2>Our Top Services</h2>
        <div className="cat-grid">
          {categories.map((item, i) => (
            <div key={i} className="cat-card">
              <i className={`fa-solid ${item.icon}`}></i>
              <h3>{item.title}</h3>
              <p>{item.desc}</p>
            </div>
          ))}
        </div>
      </section>

      {/* TESTIMONIALS */}
      <section className="testimonials">
        <h2>What Our Clients Say</h2>
        <div className="testi-grid">
          {testimonials.map((t, i) => (
            <div className="testi-card" key={i}>
              <img src={t.image} alt={t.name} />
              <h4>{t.name}</h4>
              <p>"{t.review}"</p>
            </div>
          ))}
        </div>
      </section>

      {/* CTA */}
      <section className="cta">
        <h2>Become a Cleaner or Find One Near You</h2>
        <p>Join Cleanering today — it’s quick, safe, and profitable!</p>
        <div className="cta-buttons">
          <a href="#" className="btn primary">Register as Cleaner</a>
          <a href="#" className="btn secondary">Find Services</a>
        </div>
      </section>
    </>
  );
};

export default Home;